export default __webpack_public_path__ + "static/media/En_Proveedor.3733617f.svg";